import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { processQuestionText } from '../../../../../utils/shared/probeDetailUtils';
import { PROBE_DETAIL, ELLIPSES } from '../../../../../constants/shared/CommonConstants';
import QuestionItem from './QuestionItem';
import { generateReactKey } from '../../../../../utils/shared/commonUtils';

const getResponseByQuestionId = (questionId, result) =>
    result.itemLevelDetails.find(itemLevel => itemLevel.itemIdx === questionId.toString());

const isResponseCorrect = response => get(response, 'score', '') === PROBE_DETAIL.CORRECT_RESPONSE;

export const processAnswers = (answers, response) => {
    const studentResponse = get(response, 'response', '');
    return answers.map(answer => {
        const isStudentAnswer = Array.isArray(studentResponse)
            ? studentResponse.includes(answer.id)
            : studentResponse === answer.id;
        return { ...answer, isStudentAnswer };
    });
};

const Comprehension = ({ questions, bookResult }) => (
    <div className="comprehension-content">
        {questions.map((question, index) => {
            const response = getResponseByQuestionId(question.id, bookResult.comprehensionResult);

            return (
                <QuestionItem
                    key={generateReactKey(question.id)}
                    sequenceNumber={index + 1}
                    isCorrect={isResponseCorrect(response)}
                    questionText={processQuestionText(question.text, ELLIPSES)}
                    answers={processAnswers(question.answers, response)}
                />
            );
        })}
    </div>
);

Comprehension.defaultProps = {
    questions: [],
    bookResult: {},
};

Comprehension.propTypes = {
    questions: PropTypes.array,
    bookResult: PropTypes.object,
};

export default Comprehension;
